import { createApi } from "@reduxjs/toolkit/query/react";
import { apiRequestBaseQuery } from "../../services/rtkBaseQuery";
import { getUserDetails } from "../../services/apiRequest";
import { requestType } from "../../services/requests";

// =============================================================================
// ROYAL MOMENTUM - Growth Priorities API
// =============================================================================

export const royalMomentumGrowthPrioritiesApi = createApi({
    reducerPath: "royalMomentumGrowthPrioritiesApi",
    baseQuery: apiRequestBaseQuery,
    tagTypes: ["GrowthPriorities"],
    endpoints: (builder) => ({
        // Royal Guru target (Growth Priorities card) — V2.
        // Inline payload: `agency_id` replaces `travel_agency_uid`
        // (value = selectedBrand.uid = agency_id_no_r).
        getProRoyalGuruTarget: builder.query({
            query: (params) => {
                const userDetails = getUserDetails();
                return {
                    requestType: requestType.getGrowthPrioritiesRoyalGuruTargetV2,
                    data: {
                        user_uid: userDetails?.user_details?.uid,
                        agency_id: params?.travelAgencyUid || null,
                        region: params?.region === "all" ? null : params?.region || null,
                    },
                };
            },
            providesTags: ["GrowthPriorities"],
        }),

        // My Royal Genie signup (Growth Priorities card) — V2.
        // Inline payload: `agency_id` replaces `travel_agency_uid`
        // (value = selectedBrand.uid = agency_id_no_r).
        getProRoyalGenieSignup: builder.query({
            query: (params) => {
                const userDetails = getUserDetails();
                return {
                    requestType: requestType.getGrowthPrioritiesRoyalGenieSignupV2,
                    data: {
                        user_uid: userDetails?.user_details?.uid,
                        agency_id: params?.travelAgencyUid || null,
                        region: params?.region === "all" ? null : params?.region || null,
                    },
                };
            },
            providesTags: ["GrowthPriorities"],
        }),

        // Stores certification (Growth Priorities card) — V2.
        // Inline payload: `agency_id` replaces `travel_agency_uid`
        // (value = selectedBrand.uid = agency_id_no_r).
        getProStoresCertification: builder.query({
            query: (params) => {
                const userDetails = getUserDetails();
                return {
                    requestType: requestType.getGrowthPrioritiesStoresCertificationV2,
                    data: {
                        user_uid: userDetails?.user_details?.uid,
                        agency_id: params?.travelAgencyUid || null,
                        region: params?.region === "all" ? null : params?.region || null,
                    },
                };
            },
            providesTags: ["GrowthPriorities"],
        }),

        // Meetings logged in last 60 days (Growth Priorities card) — V2.
        // Inline payload: `agency_id` replaces `travel_agency_uid`
        // (value = selectedBrand.uid = agency_id_no_r).
        getProMeetingsLoggedIn60Days: builder.query({
            query: (params) => {
                const userDetails = getUserDetails();
                return {
                    requestType: requestType.getGrowthPrioritiesMeetingsLoggedIn60DaysV2,
                    data: {
                        user_uid: userDetails?.user_details?.uid,
                        agency_id: params?.travelAgencyUid || null,
                        region: params?.region === "all" ? null : params?.region || null,
                    },
                };
            },
            providesTags: ["GrowthPriorities"],
        }),
    }),
});

export const {
    useGetProRoyalGuruTargetQuery,
    useGetProRoyalGenieSignupQuery,
    useGetProStoresCertificationQuery,
    useGetProMeetingsLoggedIn60DaysQuery,
} = royalMomentumGrowthPrioritiesApi;
